
import Layout from '@/layout'

const overseasRouter = {
  path: '/sys-overseas',
  component: Layout,
  name: 'routeOverseas',
  meta: {
    title: 'routeOverseas',
    icon: 'frame31'
  },
  children: [
    {
      path: 'sys-vehicle-navigation',
      component: () => import('@/views/sys-overseas/sys-vehicleNavigation/sys-vehicle-navigation'),
      name: 'VehicleNavigation',
      meta: { title: 'routeVehicleNavigation', icon: 'car', code: 'oversea:material' }
    },
    {
      path: 'sys-language-list',
      component: () => import('@/views/sys-overseas/sys-language/sys-language-list'),
      name: 'SysLanguage',
      meta: { title: 'routeLanguage', icon: 'frame1', code: 'multi:language' }
    },
    {
      path: 'sys-dataManagement',
      component: () => import('@/views/sys-overseas/sys-dataManagement/sys-data-management'),
      name: 'DataManagement',
      meta: { title: 'routeOverseasData', icon: 'frame19', code: 'oversea:data' }
    },
    {
      path: 'sys-subscription-rights-management',
      component: () => import('@/views/sys-overseas/sys-subscriptionRightsManagement/sys-subscription-rights-management'),
      name: 'SubscriptionRightsManagement',
      meta: { title: 'routeSubscriptionRightsManagement', icon: 'frame19', code: 'oversea:subscription:page' }
    }
  ]
}

export default overseasRouter
